import { getApiErrorMessage } from "./axios";

/**
 * If the API returned a billing 402, toast with a link to billing.
 * Returns true when handled.
 */
export function handleBillingError(error, toastError) {
  const status = error?.response?.status;
  const data = error?.response?.data || {};
  if (status !== 402) return false;
  const path = data.billing_path || "/account/billing/";
  const message = data.error || getApiErrorMessage(error, "Upgrade required.");
  toastError(message, 0, {
    key: data.code || "billing",
    link: path,
    linkLabel: "Go to billing",
  });
  return true;
}
